"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const semver = require("semver");
const text = require("react-addons-text-content");
exports.versionColor = (props) => {
    const v = text(props.children);
    if (!semver.valid(v)) {
        return props.theme.colors.error;
    }
    if (semver.satisfies(v, "<=0.1")) {
        return props.theme.colors.error;
    }
    if (semver.satisfies(v, "> 0.1 < 1")) {
        return props.theme.colors.warning;
    }
    return props.theme.colors.success;
};
function has(val) {
    return Array.isArray(val) && val.length > 0;
}
exports.has = has;
//# sourceMappingURL=info-pane.utils.js.map